import React from 'react';
import { CheckCircleIcon, AlertCircleIcon, ClockIcon } from 'lucide-react';
export const StatusPanel = () => {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-492">
      <h2 className="text-lg font-semibold mb-4" data-id="element-493">Estado General</h2>
      <div className="space-y-4" data-id="element-494">
        <div className="flex items-center justify-between p-4 bg-green-50 rounded-lg" data-id="element-495">
          <div className="flex items-center gap-3" data-id="element-496">
            <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-497" />
            <span className="font-medium text-green-700" data-id="element-498">
              Sistemas Operativos
            </span>
          </div>
          <span className="text-sm text-green-600" data-id="element-499">5/5</span>
        </div>
        <div className="flex items-center justify-between p-4 bg-yellow-50 rounded-lg" data-id="element-500">
          <div className="flex items-center gap-3" data-id="element-501">
            <AlertCircleIcon className="h-5 w-5 text-yellow-500" data-id="element-502" />
            <span className="font-medium text-yellow-700" data-id="element-503">Alertas Activas</span>
          </div>
          <span className="text-sm text-yellow-600" data-id="element-504">2</span>
        </div>
        <div className="flex items-center justify-between p-4 bg-blue-50 rounded-lg" data-id="element-505">
          <div className="flex items-center gap-3" data-id="element-506">
            <ClockIcon className="h-5 w-5 text-blue-500" data-id="element-507" />
            <span className="font-medium text-blue-700" data-id="element-508">
              Tiempo de Respuesta
            </span>
          </div>
          <span className="text-sm text-blue-600" data-id="element-509">238ms</span>
        </div>
      </div>
    </div>;
};